<template>
    <div class="flex-1 center">
        <h1>{{ $("res_Msgs_Redirecting")}}</h1>
    </div>
</template>

<script>
import constants from '@/assets/js/constants'
import axios from 'axios'
	export default {
		name: 'DsReturn',
        data () 
        {
            return {
            }
        },
        methods:
        {
            getDocumentsFromDocusign(enableMultiPageSplit, isRejected, impersonatedSignature, envelopeId, storageAttachmentId, mainAttachmentName, 
                mainAttachmentExtension, userId, documentId, transferId, structureId, delegationId) 
            {
                window.showLoading();
                axios.post(constants.baseApiUrl + 'Document/MarkDocumentAsSignedFromDocuSign?envelopeId=' + envelopeId + '&storageAttachmentId=' +
                        storageAttachmentId + '&mainAttachmentName=' + mainAttachmentName+ '&mainAttachmentExtension=' + mainAttachmentExtension +
                        '&userId=' + userId + '&documentId=' + documentId + '&transferId=' + transferId + '&structureId=' + structureId + 
                        '&delegationId=' + delegationId)
                    .then(res => 
                    {
                        window.hideLoading()
                        window.close()

                        window.refreshAfterClosingSignMethodSelect()
                    })
                    .catch(error => console.log(error))
            },
            getAttachmentFromDocusign(envelopeId,storageAttachmentId,mainAttachmentName,mainAttachmentExtension,documentId) 
            {
                window.showLoading();
                axios.post(constants.baseApiUrl + 'Document/MarkAttachmentAsSignedFromDocuSign?envelopeId=' + envelopeId + '&storageAttachmentId=' +
                        storageAttachmentId + '&mainAttachmentName=' + mainAttachmentName+ '&mainAttachmentExtension=' + mainAttachmentExtension + 
                        '&documentId=' + documentId)
                    .then(res => 
                    {
                        window.hideLoading()
                        window.close()
                    })
                    .catch(error => console.log(error))
            },
        },
        mounted () 
        {
            if (window.location.href.includes('dsReturn'))
            {
                document.getElementsByClassName('topnavbar-wrapper')[0].style.display="none"
                document.getElementsByClassName('sidebar')[0].style.display="none"
                document.getElementsByTagName('img')[0].style.display="none"
            }

            const urlParams = new URLSearchParams(window.location.search);
            const envelopeid = urlParams.get('envelopeId');
            const storageAttachmentId = urlParams.get('storageAttachmentId');
            const mainAttachmentName = urlParams.get('mainAttachmentName');
            const mainAttachmentExtension = urlParams.get('mainAttachmentExtension');
            const userId = urlParams.get('userId');
            const documentId = urlParams.get('documentId');
            const transferId = urlParams.get('transferId');
            const structureId = urlParams.get('structureId');
            const delegationId = urlParams.get('delegationId');
            const isRejected = urlParams.get('isRejected');
            const impersonatedSignature = urlParams.get('impersonatedSignature');
            const enableMultiPageSplit = urlParams.get('enableMultiPageSplit');
            const method = urlParams.get('method');
            
            if (method== "signMainDocument" )
            {
                if (envelopeid && envelopeid != '' && storageAttachmentId && storageAttachmentId != '' && mainAttachmentName && mainAttachmentName !='' 
                    && mainAttachmentExtension && mainAttachmentExtension != '' && userId &&userId != '' && documentId && documentId != '' && transferId 
                    && transferId != '' && structureId && structureId != '' && delegationId && delegationId != '' && isRejected && isRejected != '' 
                    && impersonatedSignature && impersonatedSignature != '' && enableMultiPageSplit && enableMultiPageSplit != '')
                {
                    this.getDocumentsFromDocusign(
                        enableMultiPageSplit, isRejected, impersonatedSignature, envelopeid, storageAttachmentId, mainAttachmentName, 
                        mainAttachmentExtension, userId, documentId, transferId, structureId, delegationId)
                }
            }
            else if (method=="signAttachment" && storageAttachmentId && storageAttachmentId != '')
            {
                this.getAttachmentFromDocusign(envelopeid, storageAttachmentId, mainAttachmentName, mainAttachmentExtension, documentId)
            }
        },
	}
</script>

<style>
    .center { text-align: center; }
    .center h1 {
        vertical-align: middle;
        align-content: center;
        align-items: center;
        margin-top:25%;
    }
</style>